import { render } from "./Guide.vue?vue&type=template&id=3c993724&scoped=true"
import script from "./Guide.vue?vue&type=script&lang=js"
export * from "./Guide.vue?vue&type=script&lang=js"

import "./Guide.vue?vue&type=style&index=0&id=3c993724&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c993724"]])

export default __exports__